/**
 * Arabic for the flight data feeds screen. Proposed; pending native aviation
 * review. Standard names (IATA AIDX, Type B, MVT, LDM, ASM, SSM, SITA,
 * Amadeus, IMAP, OAuth, JSON), variable names (SLT_FEED_…) and addresses are
 * kept as written.
 */
const ar: Record<string, string> = {
  /* the menu, the suite and the page */
  "Flight data feeds": "تغذيات بيانات الرحلات",
  "The live channel from the airlines' and the airport's own systems into the flight record: IATA AIDX and Type B messages (MVT, LDM, ASM, SSM) pushed by a SITA or Amadeus gateway, or fetched from a service or a mailbox. Each feed is live, quiet or failing with its lag; every message is kept as it arrived with what became of it — taken, held, stored for a person, a duplicate, or refused with the reason — and a held one can be replayed; secrets are named, never kept.":
    "القناة المباشرة من أنظمة شركات الطيران والمطار إلى سجل الرحلات: رسائل IATA AIDX ورسائل Type B (MVT وLDM وASM وSSM) التي ترسلها بوابة SITA أو Amadeus، أو التي تُجلب من خدمة أو صندوق بريد. لكل تغذية حالة — نشطة أو هادئة أو متعطلة — مع مدة التأخر؛ وتُحفظ كل رسالة كما وصلت مع ما آلت إليه — مقبولة، أو معلّقة، أو محفوظة لمراجعة شخص، أو مكررة، أو مرفوضة مع السبب — ويمكن إعادة معالجة المعلّقة؛ والأسرار تُسمّى ولا تُحفظ أبداً.",
  "The live channel from the airlines' and the airport's own systems into the flight record: IATA AIDX and Type B messages (MVT, LDM, ASM, SSM) pushed to the platform, or fetched from a service or a mailbox. Every message is kept as it arrived, with what became of it and why.":
    "القناة المباشرة من أنظمة شركات الطيران والمطار إلى سجل الرحلات: رسائل IATA AIDX ورسائل Type B (MVT وLDM وASM وSSM) التي تُرسل إلى المنصة، أو التي تُجلب من خدمة أو صندوق بريد. تُحفظ كل رسالة كما وصلت، مع ما آلت إليه وسببه.",
  "Sample feeds — no airline or airport system is connected. Configure a feed to connect one.":
    "تغذيات تجريبية — لا يوجد نظام لشركة طيران أو للمطار متصل. اضبط تغذية لتوصيل نظام.",
  "No flight data feed is configured. Configure one for each system that sends flight messages — its SITA or Amadeus team then points their output at it.":
    "لم تُضبط أي تغذية لبيانات الرحلات. اضبط تغذية لكل نظام يرسل رسائل الرحلات — ثم يوجّه فريق SITA أو Amadeus لديه مخرجاته إليها.",

  /* Sky */
  "{n} feeds: {l} live, {q} quiet, {f} failing.": "{n} تغذيات: {l} نشطة، و{q} هادئة، و{f} متعطلة.",
  "{name} is failing: {why}": "{name} متعطلة: {why}",
  "Which feeds are failing?": "ما التغذيات المتعطلة؟",

  /* tabs */
  "Feed status": "حالة التغذيات",
  "Message log": "سجل الرسائل",
  Configure: "الضبط",

  /* states and outcomes, as this screen means them */
  "Live@feed": "نشطة",
  "Quiet@feed": "هادئة",
  "Failing@feed": "متعطلة",
  "Off@feed": "متوقفة",
  "Taken@feed": "مقبولة",
  "Held@feed": "معلّقة",
  "Stored@feed": "محفوظة",
  "Duplicate@feed": "مكررة",
  "Refused@feed": "مرفوضة",

  /* what a feed sends and how it arrives */
  "IATA AIDX (XML)": "IATA AIDX (XML)",
  "Type B (MVT, LDM, ASM, SSM)": "Type B (MVT وLDM وASM وSSM)",
  "JSON, mapped": "JSON بمطابقة حقول",
  "Pushed to us": "تُرسل إلينا",
  "Fetched over HTTPS": "تُجلب عبر HTTPS",
  "Read from a mailbox (IMAP)": "تُقرأ من صندوق بريد (IMAP)",

  /* a feed's card */
  "under a minute": "منذ أقل من دقيقة",
  "{m} min ago": "منذ {m} دقيقة",
  "{h} h {m} min ago": "منذ {h} ساعة و{m} دقيقة",
  "{d} days ago": "منذ {d} يوم",
  "last message": "آخر رسالة",
  "messages in the last hour": "الرسائل في الساعة الأخيرة",
  "behind the source": "التأخر عن المصدر",
  "{n} s on average": "{n} ثانية في المتوسط",
  "where it comes from": "من أين تأتي",
  "in 24 hours": "خلال 24 ساعة",
  "Refused, by reason": "المرفوض، حسب السبب",
  "secret: {role}": "السر: {role}",
  set: "مضبوط",

  /* the message log */
  "Newest first. Open one to see it as it arrived.": "الأحدث أولاً. افتح رسالة لتراها كما وصلت.",
  Feed: "التغذية",
  Outcome: "النتيجة",
  "every feed": "كل التغذيات",
  "every outcome": "كل النتائج",
  "No messages match.": "لا رسائل مطابقة.",
  "Why, or what changed": "السبب، أو ما تغيّر",
  "posted directly": "أُرسلت مباشرة",
  "Not read (ignored and reported):": "لم يُقرأ (أُهمل وأُبلغ عنه):",
  "Sent {sent}, received {received}.": "أُرسلت {sent}، واستُلمت {received}.",
  "Replay this message": "أعد معالجة هذه الرسالة",
  "Replayed: {outcome}": "أُعيدت معالجتها: {outcome}",

  /* the settings */
  "Settings for {name}": "إعدادات {name}",
  "A new feed": "تغذية جديدة",
  "Key (in the push address)": "المفتاح (في عنوان الإرسال)",
  "What it sends": "ما ترسله",
  "How it arrives": "كيف تصل",
  "Address to fetch from": "العنوان الذي تُجلب منه",
  "Position parameter": "معامل الموضع",
  "an API key in a header": "مفتاح API في ترويسة",
  "OAuth client credentials": "بيانات عميل OAuth",
  Header: "الترويسة",
  "Token address": "عنوان الرمز",
  "Client id": "معرّف العميل",
  "Mail server (IMAPS, port 993)": "خادم البريد (IMAPS، المنفذ 993)",
  "Mailbox user": "مستخدم صندوق البريد",
  Folder: "المجلد",
  "Secret name: {role}": "اسم السر: {role}",
  "Name the environment variable that holds it (SLT_FEED_…), set from the deployment's secret manager. The secret itself is never typed here, kept or shown.":
    "سمِّ متغير البيئة الذي يحمله (SLT_FEED_…)، ويُضبط من مدير الأسرار في بيئة التشغيل. لا يُكتب السر نفسه هنا ولا يُحفظ ولا يُعرض أبداً.",
  "Field mapping (JSON)": "مطابقة الحقول (JSON)",
  "Fetch every (seconds)": "اجلب كل (ثانية)",
  "Quiet after (minutes without a message)": "هادئة بعد (دقائق بلا رسالة)",
  "May add flights the schedule does not have (charters, ad-hoc). Off, a flight not on the record is held.":
    "يمكنها إضافة رحلات ليست في الجدول (رحلات عارضة وخاصة). عند الإيقاف، تُعلَّق الرسالة عن رحلة ليست في السجل.",
  "Save the settings": "احفظ الإعدادات",
  "Add the feed": "أضف التغذية",
  "New feed instead": "تغذية جديدة بدلاً منها",
  "The key is 2–40 lower-case letters, digits, - or _; it goes in the push address.":
    "المفتاح من 2 إلى 40 حرفاً لاتينياً صغيراً أو رقماً أو - أو _؛ ويدخل في عنوان الإرسال.",
  "The feed needs a name.": "التغذية تحتاج إلى اسم.",
  "A mailbox carries Type B.": "صندوق البريد يحمل رسائل Type B.",
  "A JSON feed is fetched over HTTPS.": "تغذية JSON تُجلب عبر HTTPS.",
  "A fetched feed needs its address (https://…).": "التغذية المجلوبة تحتاج إلى عنوانها (https://…).",
  "A mailbox needs its host and user.": "صندوق البريد يحتاج إلى الخادم والمستخدم.",
  "A secret is named, never typed: {v} is not an SLT_FEED_… variable name.":
    "السر يُسمّى ولا يُكتب: {v} ليس اسم متغير SLT_FEED_….",
  "The field mapping is not valid JSON.": "مطابقة الحقول ليست JSON صالحاً.",

  /* testing */
  "Test it": "اختبرها",
  "A sample message, or one fetch from the source — read and checked, and nothing applied.":
    "رسالة نموذجية، أو جلبة واحدة من المصدر — تُقرأ وتُفحص، ولا يُطبَّق شيء.",
  "Save the feed first; then send it a sample here.": "احفظ التغذية أولاً، ثم أرسل إليها نموذجاً هنا.",
  "Test with this sample": "اختبر بهذا النموذج",
  "Fetch once, apply nothing": "اجلب مرة واحدة دون تطبيق شيء",
  "Nothing came back to read.": "لم يرجع شيء للقراءة.",
};

export default ar;
